import * as React from 'react';
import { limuirsComponent } from 'limuirs-components';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { nodeType } from '../../../types';

/**
 * Title for a node, includes icon for membership type if node supports membership.
 *
 * @author Patricio Poratto, Adam Ayres
 */
const NodeTitle = ({ node, text, useLink, useMembershipTypeIcon }) => {
  const isClosed = _.has(node, 'membership_type') && node.membership_type !== 'open';
  const typeIcon = isClosed ? <i className="lia-fa lia-fa-lock" /> : undefined;
  const title = (
    <>
      {text.format('title', { title: node.title })} {useMembershipTypeIcon && typeIcon}
    </>
  );

  return node.title && node.view_href ? (
    <h4 className="lia-node-title">
      {useLink ? (
        <a className="lia-link-navigation" href={node.view_href}>
          {title}
        </a>
      ) : (
        <>{title}</>
      )}
    </h4>
  ) : null;
};

NodeTitle.propTypes = {
  /** The node to display the title of. (node.title) */
  node: nodeType.isRequired,
  /** Whether the title will link to the node */
  useLink: PropTypes.bool,
  /** Whether the membership type icon appears after the title for nodes that support membership */
  useMembershipTypeIcon: PropTypes.bool
};

NodeTitle.defaultProps = {
  useLink: true,
  useMembershipTypeIcon: true
};

export default limuirsComponent(module, NodeTitle, { inert: true });
